import { useManager } from 'dreamstate';
import { memo, useEffect, useRef, useState } from 'react';

import { ChartGrowthAlt } from '@vimeo/bokeh-icons';
import { Maybe } from '@vimeo/core/types/generic';

import { IPollContext, PollManager } from '../../../../store/firebase/interaction/poll';
import { EPollState, IPoll } from '../../../../types/interaction_tools';
import { IInteractionStoreInitialState } from '../../../../types/store';
import { useLiveGlobals } from '../../../providers/globals';
import { IconNotification } from './IconNotification';

/**
 * Hook for detect changes in polls and set true flag for notification.
 * @param isActive represents that polls is active module
 */

interface IPanelPollIconProps {
  isActive: boolean;
  pollContext?: IPollContext;
}

export const PanelPollIcon = memo(function ({
  isActive,
  // eslint-disable-next-line react-hooks/rules-of-hooks
  pollContext: { polls, activePollId } = useManager(PollManager, ({ polls, activePollId }) => [
    polls,
    activePollId,
  ]),
}: IPanelPollIconProps) {
  const {
    initialState: { renderAt },
  } = useLiveGlobals<IInteractionStoreInitialState>();

  const lastSeen = useRef<number>((renderAt as number) + 100); // +100 for rendering delay
  const lastPollState = useRef<EPollState>(EPollState.OPENED);
  const [hasNotification, setHasNotification] = useState<boolean>(false);

  const activePoll: Maybe<IPoll> = activePollId ? polls[activePollId] : null;

  useEffect(() => {
    setHasNotification(() => {
      if (activePoll) {
        if (isActive) {
          lastSeen.current = activePoll?.updatedAt ? activePoll?.updatedAt : activePoll.createdAt;
          lastPollState.current = activePoll.state;
          return false;
        } else {
          return (
            activePoll.createdAt > lastSeen.current ||
            (activePoll?.updatedAt as number) > lastSeen.current ||
            activePoll.state !== lastPollState.current
          );
        }
      } else {
        return false;
      }
    });
  }, [isActive, activePoll]);

  return (
    <IconNotification isVisible={hasNotification}>
      <ChartGrowthAlt />
    </IconNotification>
  );
});
